import React, { ComponentProps, FunctionComponent } from "react";

const LogoInstagramIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 17",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9716 0.542969H5.82731C3.10468 0.542969 0.895508 2.75214 0.895508 5.47476V11.6147C0.895508 14.3373 3.10036 16.5422 5.82731 16.5422H11.9672C14.6899 16.5422 16.8947 14.3373 16.8947 11.6147V5.47476C16.899 2.74782 14.6942 0.542969 11.9716 0.542969ZM15.363 11.0236C15.363 13.2241 13.581 15.0061 11.3804 15.0061H6.41843C4.21789 15.0061 2.43589 13.2241 2.43589 11.0236V6.06157C2.43589 3.86104 4.21789 2.07903 6.41843 2.07903H11.3804C13.581 2.07903 15.363 3.86535 15.363 6.06157V11.0236Z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.11398 4.35547C6.784 4.35547 4.89844 6.24103 4.89844 8.57101C4.89844 10.8967 6.784 12.7865 9.11398 12.7865C11.4396 12.7865 13.3295 10.901 13.3295 8.57101C13.3252 6.24103 11.4396 4.35547 9.11398 4.35547ZM9.11398 11.1038C7.71168 11.1038 6.57689 9.969 6.57689 8.56669C6.57689 7.16439 7.71168 6.0296 9.11398 6.0296C10.512 6.0296 11.6511 7.16439 11.6511 8.56669C11.6468 9.969 10.512 11.1038 9.11398 11.1038Z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.1069 4.29313C14.1069 4.88425 13.628 5.3632 13.0369 5.3632C12.4457 5.3632 11.9668 4.88425 11.9668 4.29313C11.9668 3.70201 12.4457 3.21875 13.0369 3.21875C13.628 3.21875 14.1069 3.69769 14.1069 4.29313Z",
      fill: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(LogoInstagramIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
